import React, { useState, useEffect, useRef } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";

const Carousel = props => {
  const { images } = props;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [swiper, setSwiper] = useState()

  const prevRef = useRef();
  const nextRef = useRef();

  useEffect(() => {
    if (swiper) {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    }
}, [swiper]);

  return (
    <div className="w-full">
      <Swiper
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        onSwiper={setSwiper}
        loop={true}
        modules={[ Navigation, Thumbs]}
        className="mySwiper2 border border-primary w-full"
      >
        {images?.map(image => {
          return (
            <SwiperSlide className="mx-auto">
              <GatsbyImage
                image={getImage(image?.localFile)}
                class="h-96 w-full"
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={4}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper mt-2"
      >
        {images?.map(image => {
          return (
            <SwiperSlide className="">
              <GatsbyImage
                image={getImage(image?.localFile)}
                class="h-32 border border-primary cursor-pointer"
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  );
}

export default Carousel